import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import store from './store/state'
import './registerServiceWorker'
import router from './router'
import vuetify from './plugins/vuetify';
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)




Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')